export const shallowEqual = (
  obj1: Record<string, unknown> | undefined,
  obj2: Record<string, unknown> | undefined,
) =>
  obj1 &&
  obj2 &&
  Object.keys(obj1).length === Object.keys(obj2).length &&
  Object.keys(obj1).every(
    (key) => Object.hasOwn(obj2, key) && obj1[key] === obj2[key],
  );
